module.exports = __webpack_public_path__ + "img/b2afebe130ce13231e1d35e668eca253.68bd5860.jpg";